import React from 'react';
import { Hero } from '../components/SalesPage/Hero';
import { OpeningLead } from '../components/SalesPage/OpeningLead';
import { ProblemSection } from '../components/SalesPage/ProblemSection';
import { SolutionSection } from '../components/SalesPage/SolutionSection';
import { RiskMapSection } from '../components/SalesPage/RiskMapSection';
import { MidPageCTA } from '../components/SalesPage/MidPageCTA';
import { WhatsInsideSection } from '../components/SalesPage/WhatsInsideSection';
import { WhyItWorksSection } from '../components/SalesPage/WhyItWorksSection';
import { WhoItIsForSection } from '../components/SalesPage/WhoItIsForSection';
import { PricingSection } from '../components/SalesPage/PricingSection';
import { Footer } from '../components/SalesPage/Footer';
import { FAQSection } from '../components/SalesPage/FAQSection';
import { GuaranteeSection } from '../components/SalesPage/GuaranteeSection';
import { StickyCtaBar } from '../components/SalesPage/StickyCtaBar';
export function SalesPage() {
  return <div className="min-h-screen bg-[#0B0E13] font-sans selection:bg-[#D4A843] selection:text-[#0B0E13]" data-id="element-408">
      <Hero data-id="element-409" />
      <OpeningLead data-id="element-410" />
      <ProblemSection data-id="element-411" />
      <SolutionSection data-id="element-412" />
      <RiskMapSection data-id="element-413" />
      <MidPageCTA data-id="element-414" />
      <WhatsInsideSection data-id="element-415" />
      <WhyItWorksSection data-id="element-416" />
      <WhoItIsForSection data-id="element-417" />
      <GuaranteeSection data-id="element-418" />
      <PricingSection data-id="element-419" />
      <FAQSection data-id="element-420" />
      <Footer data-id="element-421" />
      <StickyCtaBar data-id="element-422" />
    </div>;
}